<div>
  <ng-content select="[title]"></ng-content>
  <div class="text-muted">
    <ng-content select="[body]"></ng-content>
  </div>
</div>
<div *ngIf="removable" class="flex-center" (click)="remove.emit()">
  <app-icon name="times"></app-icon>
</div>
